import React from 'react';
import { Instagram } from 'lucide-react';
import { instagramReels, gymInfo } from '../data/mockData';

const InstagramReels = () => {
  return (
    <section className="section-padding bg-page relative z-10">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="heading-2 mb-6 gradient-text">האווירה שלנו</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto mb-8">
            הצצה לחוויית האימון האותנטית שלנו
          </p>
          <a 
            href={gymInfo.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-wood-lighter hover:text-wood-light transition-colors body-medium"
          >
            <Instagram size={24} />
            <span>עקבו אחרינו באינסטגרם</span>
          </a>
        </div>

        {/* Reels Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {instagramReels.map((reel, index) => (
            <div 
              key={reel.id}
              className="instagram-reel-wrapper scroll-reveal-scale"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="instagram-reel-container">
                <iframe
                  src={reel.embedUrl}
                  className="instagram-reel-iframe"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency="true"
                  allow="encrypted-media"
                  title={reel.description}
                ></iframe>
              </div>
              <a
                href={reel.url}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-reel-link"
              >
                <Instagram size={20} />
                <span>צפה באינסטגרם</span>
              </a>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 scroll-reveal">
          <a
            href={gymInfo.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <Instagram size={20} />
            <span>עוד סרטונים באינסטגרם</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramReels;
